<label [ngClass]="[styles.tglBtnLabel, disabled ? styles.tglDisabled : '']">
	<input type="checkbox" [ngClass]="[styles.tglInput, styles.visuallyHidden]" [id]="toggleId" [(ngModel)]="value" [disabled]="disabled" [attr.aria-label]="ariaLabel" [attr.aria-checked]="value" (ngModelChange)="onChange()">
	<div [ngClass]="styles.tglBtn">
		<div [ngClass]="styles.tglBtnTrack">
			<div [ngClass]="styles.check" class="vb-icon vb-icon-round-check"></div>
		</div>
	</div>
</label>
